import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ChatProvider } from "@/context/ChatContext";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import "@/App.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white px-6">
          <div className="max-w-md text-left">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-brand-600">Ops</p>
            <h1 className="mt-2 font-display text-2xl font-bold text-slate-900">Algo saiu do trilho por aqui.</h1>
            <p className="mt-2 text-slate-600">Recarregue a página para continuar. Se o problema persistir, fale com a Isabela pelo WhatsApp.</p>
            <button
              data-testid="reload-page-button"
              onClick={() => window.location.reload()}
              className="mt-6 rounded-full bg-brand-600 px-6 py-3 text-sm font-bold text-white hover:bg-brand-700 transition-colors"
            >
              Recarregar página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ChatProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
    </ChatProvider>
  );
}

export default App;
